import { Icon } from '@pwc/pwc-deals-ui';
import React from 'react';
import CONSTANTS from './Constants';

const ReportLayoutIcon = ({ layoutType }) => {
  const iconName = CONSTANTS.LAYOUT_TO_ICON[layoutType];

  return <Icon name={iconName} className="fill icon-orange" />;
};

export default ReportLayoutIcon;
